import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'notes-reference-settings',
    templateUrl: './notes-reference-settings.component.html',
    styleUrls: ['./notes-reference-settings.component.scss'],
})
export class NotesReferenceSettingsComponent implements OnInit {
    @Output() onBtnClick = new EventEmitter();
    @Output() onAddNumberToggleChange = new EventEmitter<boolean>();
    @Input() addNumbering: boolean | undefined;
    @Input() disabled = false;

    onClick(): void {
        this.onBtnClick.emit();
    }

    ngOnInit(): void {
        this.addNumbering = this.addNumbering ?? true;
    }

    onAddNumberChange(checked: boolean): void {
        this.onAddNumberToggleChange.emit(checked);
    }
}
